import { render } from "./LbrxPaginationNumbers.vue?vue&type=template&id=4b422247&scoped=true"
import script from "./LbrxPaginationNumbers.vue?vue&type=script&lang=js"
export * from "./LbrxPaginationNumbers.vue?vue&type=script&lang=js"

import "./LbrxPaginationNumbers.vue?vue&type=style&index=0&id=4b422247&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b422247"]])

export default __exports__